/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-12 14:23:05
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 16:46:56
 *  */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../../app/store'
import { sendAsync } from '../../../app/applicationSlice'
import { checkPermission, checkPermissionParams, geDataPermissonList, getSubmitBatch } from '../../../services/dataPermision'

export const getSubmitBatchAsync = createAsyncThunk<void, any, RootThunkApi>(
  'dataPermision/getSubmitBatchAsync',
  async (body, api) => {
    return sendAsync(getSubmitBatch(body), api)
  }
)

export const geDataPermissonListAsync = createAsyncThunk<
  any,
  void,
  RootThunkApi
>('dataPermision/geDataPermissonListAsync', async (body, api) => {
  return sendAsync(geDataPermissonList(), api)
})


export const getCheckPermissionAsync = createAsyncThunk<
  void,
  checkPermissionParams,
  RootThunkApi
>('dataPermision/checkPermissionAsync', async (params, api) => {
  return sendAsync(checkPermission(params), api)
})